<template>
  <div class="notice-box">
    <div class="notice-status" :style="{'background-image': bgImage}">
      <div v-show="hasPoint" class="point"></div>
      {{ title }}
    </div>
    <div v-show="content" class="notice-content">
      <p>{{ content }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NoticeTag",
    props: {
      bgImage: {
        type: String,
        default: 'linear-gradient(-56deg, #6982FA 0%, #69A7FA 100%)'
      },
      hasPoint: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '描述'
      },
      content: {
        type: String,
        default: '内容'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .notice-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: fit-content;

    font-size: 26px;

    background-color: rgba(0, 0, 0, .3);
    border-radius: 10px;
    overflow: hidden;
    color: #fff;

    .notice-status {
      display: flex;
      align-items: center;
      padding: 4px  14px;

      border-radius: 10px;

      .point {
        margin-right: 8px;
        width: 12px;
        height: 12px;

        border-radius: 50%;
        background-color: #fff;
      }
    }

    .notice-content {
      flex: 1;
      padding: 0 10px;
      font-size: 18px;
    }
  }
</style>
